import React from "react";
import ReactLoading from "react-loading";

export default ({height, width}) => (
    <ReactLoading type="bars" color="#2e3c50" height={height} width={width}/>
);